import { inviteService } from '@/services/invites.service';

const initialState = () => ({
  invites: [],
  status: {
    error: null,
    pending: true,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getInvitesByTenant({ commit }, tenantId) {
    commit('GET_INVITES');
    return inviteService.getInvitesByTenant(tenantId).then(
      (response) => {
        commit('SET_INVITES', response);
        commit('SUCCESS');
      },
      (error) => {
        commit('ERROR', error.type);
      },
    );
  },
  sendInvite({ commit }, { tenantId, email, locale, role }) {
    commit('SEND_INVITE');
    return inviteService.sendInvite(tenantId, email, locale, role).then(
      (response) => commit('SUCCESS'),
      (error) => {
        commit('ERROR', error.data);
        throw error;
      },
    );
  },
  resendInvite({ commit }, inviteId) {
    commit('RESEND_INVITE');
    return inviteService.resendInvite(inviteId).then(
      () => commit('SUCCESS'),
      (error) => {
        commit('ERROR', error.response.data);
        throw error;
      },
    );
  },
  revokeInvite({ commit }, inviteId) {
    commit('REVOKE_INVITE');
    return inviteService.revokeInvite(inviteId).then(
      () => commit('SUCCESS'),
      (error) => {
        commit('ERROR', error.response.data);
        throw error;
      },
    );
  },
};

const mutations = {
  GET_INVITES(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SEND_INVITE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  RESEND_INVITE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SET_INVITES(state, invites) {
    state.invites = invites;
  },
  REVOKE_INVITE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  invites: (state) => state.invites,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const invites = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
